import * as React from "react";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { RouteFragment } from "../../../../../../react-core/Imports";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { ITFLSSteppersMap, productMap } from "../Resource/Contents";
import { TopUpWithITFLSStore } from "../Stores/Variable";
import { DocumentsAndDeclarations } from "./DocumentsAndDeclarations/DocumentsAndDeclarations";
import { Drawdown } from "./Drawdown/Drawdown";
import { IncomePaymentDetails } from "./IncomePaymentDetails/IncomePaymentDetails";
import { InvestmentSelectionTool as IST } from "./IST/IST";
import { PaymentsIn } from "./PaymentsIn/PaymentsIn";
import { Review } from "./Review/Review";
import { ITFLSAction } from "../Actions/ITFLSAction";
import { hasCashTransfer, hasSinglePayments } from "../../../../../Shared/IST/Components/Shared/Utils";
import { Confirmation } from "../../../../../Shared/Process/Process/Confirmation";
import { IStepConfig, StepType } from "../../../../../Shared/Process/Process/Process";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { Action } from "../../../../Actions/Action";
import { ProductDetailsStore, TreasuredAssetsStore } from "../../../../Stroes/Variable";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownCalculationStoreStore } from "../../Common/SIPP/DrawdownDetails/Store/Variable";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../../Shared/Process/AccountContextWizardComponent";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";

interface ITopUpWithITFLSWizardState extends IAccountContextWizardComponentState {
    extraInfo: {
        treasuredAssetProductIds: number[];
        treasuredAssetsInstructionId: number;
    };
}

export class TopUpWithITFLSWizard extends AccountContextWizardComponent<ITopUpWithITFLSWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: {
                treasuredAssetProductIds: null,
                treasuredAssetsInstructionId: null,
            },
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(TopUpWithITFLSStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(DrawdownCalculationStoreStore, () => this.onPostDrawdown());
    }

    private onInstructionStoreChange() {
        if (TopUpWithITFLSStore.getActionType() == ActionType.Success) {
            const data = TopUpWithITFLSStore.getData();
            this.setState({
                isLoading: false,
                data: data,
                onPosting: false,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    onClientAccountStoreChange(): void {
        super.onClientAccountStoreChange();
        const { clientAccount } = this.state;
        if (clientAccount != null) {
            const wrapcash = ProductDetailsStore.getSubAccount(SubAccountType.WrapCash);
            if (!wrapcash) {
                Action.getProductsValuationDetailSummary(
                    clientAccount.HierarchyId,
                    null,
                    JsonDateParser.toJsonDateNoOffset(new Date())
                );
            }
        }
    }

    private onPostDrawdown() {
        if (DrawdownCalculationStoreStore.getActionType() == ActionType.Loading) {
            this.setState({ onPosting: true });
        }
    }

    componentDidUpdate(prevProps: any, prevState: ITopUpWithITFLSWizardState) {
        const { customer, clientAccount, data } = this.state;
        if (prevState.customer !== customer || prevState.clientAccount !== clientAccount) {
            const id = getQueryParameters()["id"];
            if (customer && clientAccount) {
                ITFLSAction.getInstruction(id, clientAccount.HierarchyId, customer.CustomerId);
            }
        }
    }

    componentDidMount() {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        Action.getClientAccount(hierarchyId);
        Action.getAccountRoles(hierarchyId);
    }

    onCancel() {
        // ITFLSAction.deleteInstruction(this.state.data.HierarchyId, () => this.onExit());
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        ITFLSAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => this.setState({ isSubmitting: false })
        );
    }

    onTreasuredAssetsStoreChange() {
        const treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({
            extraInfo: {
                treasuredAssetProductIds: treasuredAssetProductIds,
                treasuredAssetsInstructionId: null,
            },
        });
    }

    onChangeTreasuredAssets(hierarchyId: string, productId: number, value: boolean) {
        let productIds = this.state.extraInfo.treasuredAssetProductIds;
        if (value) {
            productIds.push(productId);
        } else {
            productIds = productIds.filter((id) => id !== productId);
        }
        this.setState({
            extraInfo: {
                treasuredAssetProductIds: productIds,
                treasuredAssetsInstructionId: HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId,
            },
        });
    }

    getStepProps(index: number) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    saveInstruction(from: any, to: any, toUrl: RouteFragment, params: unknown, stepLength: number) {
        if (from == stepLength - 1) {return this.onExit();}
        if (!params["id"]) {params["id"] = this.state.data.HierarchyId;}
        ITFLSAction.saveInstruction(
            from,
            this.state.data,
            parseInt(params["type"]),
            this.state.customer?.CustomerId,
            (result) => {
                this.setState({ onPosting: false });
                if (result.length > 0) {
                    this.setState({ errorMsg: result, isShowErrorMsg: true });
                } else {
                    if (this.state.extraInfo.treasuredAssetsInstructionId) {
                        Action.setInstructionTreasuredAssetsProductIds(
                            this.state.extraInfo.treasuredAssetsInstructionId,
                            this.state.extraInfo.treasuredAssetProductIds,
                            () => {
                                this.setState({ onPosting: false });
                                this.navigate(to, toUrl, params);
                            }
                        );
                    } else {
                        this.setState({ onPosting: false });
                        this.navigate(to, toUrl, params);
                    }
                }
            }
        );
    }

    private navigate(to, toUrl, params) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    setStepperConfig() {
        const productType = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        let hasIST = 0;
        const step: IStepConfig[] = [
            {
                title: ITFLSSteppersMap.paymentsIn,
                url: Urls.get().TopUpWithITFLSPaymentsIn,
                path: Contents.URLMap.paymentIn,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <PaymentsIn {...this.getStepProps(0)} type={productType} />,
            },
        ];
        if (hasSinglePayments(data.Contribution) || hasCashTransfer(data.Contribution?.PensionTransfers)) {
            hasIST = 1;
            step.push({
                title: ITFLSSteppersMap.investment,
                url: Urls.get().TopUpWithITFLSIST,
                path: Contents.URLMap.ist,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <IST
                        {...this.getStepProps(1)}
                        type={productType}
                        treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                        onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                        onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                            this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                        }}
                    />
                ),
            });
        }
        step.push({
            title: ITFLSSteppersMap.drawdown,
            url: Urls.get().TopUpWithITFLSDrawdown,
            path: Contents.URLMap.drawdownDetail,
            onStepLeave: (from: any, to: any) => {
                this.onStepperLeave(from, to);
            },
            component: <Drawdown {...this.getStepProps(1 + hasIST)} customerId={this.state.customer?.CustomerId} />,
        });
        step.push({
            title: ITFLSSteppersMap.incomePayment,
            url: Urls.get().TopUpWithITFLSIncomePayment,
            path: Contents.URLMap.incomePayment,
            onStepLeave: (from: any, to: any) => {
                this.onStepperLeave(from, to);
            },
            component: (
                <IncomePaymentDetails
                    {...this.getStepProps(2 + hasIST)}
                    type={productType}
                    customerId={this.state.customer?.CustomerId}
                />
            ),
        });
        step.push({
            title: ITFLSSteppersMap.review,
            url: Urls.get().TopUpWithITFLSReview,
            path: Contents.URLMap.review,
            needPrint: true,
            onStepLeave: (from: any, to: any) => {
                this.onStepperLeave(from, to);
            },
            component: <Review {...this.getStepProps(3 + hasIST)} type={productType} />,
        });
        step.push({
            title: ITFLSSteppersMap.doc,
            url: Urls.get().TopUpWithITFLSDocumentsAndDeclarations,
            path: Contents.URLMap.documentAndDeclarations,
            onSubmit: () => this.onSubmit(),
            canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
            onStepLeave: (from: any, to: any) => {
                this.onStepperLeave(from, to);
            },
            component: (
                <DocumentsAndDeclarations
                    {...this.getStepProps(4 + hasIST)}
                    customerId={this.state.customer?.CustomerId}
                />
            ),
        });
        step.push({
            title: ITFLSSteppersMap.comfirm,
            url: Urls.get().TopUpWithITFLSComfirmation,
            path: Contents.URLMap.confirmation,
            type: StepType.Confirmation,
            component: (
                <Confirmation
                    onExit={() => this.onExit()}
                    successMessage={`We've successfully received your application for ${data.ClientDetails.FirstName} ${data.ClientDetails.LastName}(${data.SubAccountClientDetail?.ClAccountId})`}
                    isLoading={this.state.isSubmitting}
                />
            ),
        });
        this.stepperConfig = step;
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Top-up with immediate tax-free lump sum";
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
